export const stripTime = (d: Date): Date => {
  const res = new Date(d.getTime());
  res.setHours(0, 0, 0, 0);
  return res;
};

export const getToday = (): Date => {
  return stripTime(new Date());
};

export const dateToLocalString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseSelectableDate = (d?: string): Date | undefined => {
  if (!d) return undefined;
  const parsed = new Date(d);
  return stripTime(parsed);
};

export const clampDate = (d: Date, min?: Date, max?: Date): Date => {
  const time = d.getTime();
  const minT = min ? stripTime(min).getTime() : undefined;
  const maxT = max ? stripTime(max).getTime() : undefined;
  const clamped = new Date(
    minT !== undefined && time < minT ? minT : maxT !== undefined && time > maxT ? maxT : time
  );
  return stripTime(clamped);
};

export const isBefore = (a: Date, b: Date): boolean => {
  return stripTime(a).getTime() < stripTime(b).getTime();
};

export const isSameOrAfter = (a: Date, b: Date): boolean => {
  return stripTime(a).getTime() >= stripTime(b).getTime();
};
// ---------------------------------------------------------------------------
// Aritmetica su date ISO (YYYY-MM-DD)
//
// Volutamente in UTC: queste funzioni lavorano su giorni-calendario già
// serializzati, dove l'ora non esiste, e l'aritmetica locale su una stringa
// nuda sbaglia di un giorno nei cambi di ora legale.
// ---------------------------------------------------------------------------

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const parseISODate = (value: string): Date => {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(Date.UTC(y, (m || 1) - 1, d || 1));
};

/** Data ISO spostata di `days` giorni (anche negativi). */
export const addDays = (isoDate: string, days: number): string =>
  new Date(parseISODate(isoDate).getTime() + days * MS_PER_DAY).toISOString().slice(0, 10);

/** Giorni di distanza fra due date ISO (`to - from`). */
export const diffDays = (from: string, to: string): number =>
  Math.round((parseISODate(to).getTime() - parseISODate(from).getTime()) / MS_PER_DAY);

/** Numero di giorni inclusivo fra due date ISO: dal 1 al 3 sono 3 giorni, non 2. */
export const inclusiveDayCount = (startDate: string, endDate: string): number =>
  diffDays(startDate, endDate) + 1;
